<template>
  <div>
    <div class="main-container airfreight_tool">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/">{{ $t("header.menu.home") }}</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("header.menu.tool") }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="toolPath == '/tool/airport_code'">{{
          $t("header.menu.airportCode")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="toolPath == '/tool/hs_code'">{{
          $t("header.menu.hs")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="toolPath == '/tool/tact'">{{
          $t("header.menu.tact")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="toolPath == '/tool/airline_info'">{{
          $t("header.menu.airlineInfo")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="toolPath == '/tool/plane_type'">{{
          $t("header.menu.planeType")
        }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="v-menu">
            <el-row class="title">{{ $t("header.menu.tool") }}</el-row>
            <router-link to="/tool/airport_code" class="tool_router">{{
              $t("header.menu.airportCode")
            }}</router-link>
            <router-link to="/tool/hs_code" class="tool_router">{{
              $t("header.menu.hs")
            }}</router-link>
            <router-link to="/tool/tact" class="tool_router">{{
              $t("header.menu.tact")
            }}</router-link>
            <router-link to="/tool/airline_info" class="tool_router">{{
              $t("header.menu.airlineInfo")
            }}</router-link>
            <router-link to="/tool/plane_type" class="tool_router">{{
              $t("header.menu.planeType")
            }}</router-link>
          </div>
        </el-col>
        <el-col :span="18">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style type="text/css" scoped="true">
@import "~@/assets/css/view/tool/tool.css";
</style>
<script type="babel">
export default {
    data: function() {
        return {
            toolPath:''
        };
    },
    watch: {
        $route: function() {
            this.toolPath = window.location.pathname
        }
    },
    mounted: function() {
        this.toolPath = window.location.pathname;
    },
};
</script>
